/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Incidents API
 * AV Services Incidents management API
 * OpenAPI spec version: 1.0
 */

export interface Address {
  /** Primary street address */
  streetAddress?: string;
  /** Secondary street address */
  streetAddress2?: string;
  /** City name */
  city?: string;
  /** State or province name */
  stateProvince?: string;
  /** Postal code */
  postalCode?: string;
  /** Country name */
  country?: string;
}
